var tmpl = require('./tmpl.handlebars');

function ShowPage() {

}
ShowPage.prototype = {
  init: function() {
    var that = this;
    if (!$('.page-wrapper').length) {
      $('body').append('<div class="page-wrapper"></div>')
    }
    $(document).off('click', '.page-gallery, .close').on('click', '.page-gallery, .close', function() {
      that.destory();
    })
  },
  show: function(tmpl, callback) {
    var that = this;
    that.init();
    $('html').addClass('page-show');
    $('.page-wrapper').html('').append(tmpl);
    if ($.isFunction(callback)) {
      this.callback = callback;
    }
  },
  destory: function() {
    $('.page-wrapper').remove();
    $('html').removeClass('page-show');
  }
}

module.exports = ShowPage;